const View = (props: any) => {
  return <>{props.children}</>
}

export default View
